import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 6rem);
  font-family: 'Source Sans 3', sans-serif;
`;

export const HeaderSection = styled.div`
  background-color: ${({ theme }) => theme.colors.white4};
  padding: 1.5rem 1.5rem 0;
`;

export const FavoritesTitle = styled.h1`
  font-family: 'Source Sans 3', 'Source Sans Pro', Arial, Helvetica, sans-serif;
  color: ${({ theme }) => theme.colors.grayDark3};
  margin: 0 0 0.5rem;

  font-weight: 600;
  font-style: SemiBold;
  font-size: 48px;
  line-height: 56px;
  letter-spacing: 0px;
`;

export const FavoritesSubtitle = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grayDark4};
  margin: 0 0 1.5rem;
`;

export const SelectorsRow = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;

  > div {
    flex: 1;
    min-width: 280px;
    max-width: 380px;
  }
`;

export const SearchAndFiltersSection = styled.div`
  background-color: ${({ theme }) => theme.colors.white4};
  padding: 1rem 1.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors.gray3};
`;

export const SearchRow = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 1rem;
  max-width: 920px;

  > *:first-child {
    flex: 1;
    min-width: 0;
  }

  > button {
    flex-shrink: 0;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.white4};
  border: 1px solid ${({ theme }) => theme.colors.grayHefestoBorder};
  border-radius: 4px;
  padding: 0 0.75rem;
  gap: 0.5rem;
  height: 48px;

  svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.grayDark};
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grayDark5};
  background: transparent;

  &::placeholder {
    color: ${({ theme }) => theme.colors.grayDark};
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 2.5rem;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterLabel = styled.span`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.grayDark4};
  font-weight: 500;
  padding-left: 1.5rem;
`;

export const ContentArea = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
  flex: 1;
  padding: 1.5rem 1.5rem 8rem;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 12rem;
  text-align: center;
`;

export const EmptyStateText = styled.p`
  font-size: 1.5rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grayDark4};
  margin: 0;
  line-height: 2rem;
  font-family: Source Sans 3;
`;

export const EmptyStateLink = styled.span`
  color: ${({ theme }) => theme.colors.blue6};
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const SearchResultText = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.grayDark5};
  margin: 0 0 1rem;

  font-family: Work Sans;
  line-height: 24px;
  letter-spacing: 0px;
`;

export const PaginationContainer = styled.div<{ disableNextPage: boolean }>`
  padding: 1rem 0 0;
  ${({ disableNextPage }) =>
    disableNextPage &&
    `
    .hefesto-pagination__next {
      opacity: 0.36;
      pointer-events: none;
    }
  `}
`;

export const AdminSearchRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;

  > *:first-child {
    flex: 1;
    min-width: 0;
  }
`;

export const FavoritesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.5rem;

  @media (min-width: 992px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;
